import {Dialog, DialogContent} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import './styless.scss'
import {setGlobalDialogTips} from "../../store/memberSlice";

export default function TipsDialog(props: Record<string, never>) {

    const globalDialogTips =  useSelector((state: RootState) => state.member.globalDialogTips);

    const dispatch = useDispatch();

    const handleClose = () => {
        globalDialogTips?.cancelFun?.();
        dispatch(setGlobalDialogTips(null));
    };

    const handleConfirm = () => {
        globalDialogTips?.confirmFun?.();
        dispatch(setGlobalDialogTips(null));
    };

    const getIcon = () => {
        switch (globalDialogTips?.type) {
            case 'error':
                return <ErrorIcon className="tips-dialog-icon" sx={{ color: 'var(--c-text-primary)' }} />;
            case 'waring':
                return <WarningIcon className="tips-dialog-icon" sx={{ color: '#ff9800' }} />;
            case 'success':
                return <CheckCircleIcon className="tips-dialog-icon" sx={{ color: '#4caf50' }} />;
            case 'default':
            default:
                return <InfoIcon className="tips-dialog-icon" sx={{ color: '#2196f3' }} />;
        }
    };

    return <Dialog
        open={!!globalDialogTips}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="invitation-dialog"
    >
        <DialogContent>
            <div className="tips-dialog-content">
                <div className="tips-dialog-title">
                    {getIcon()}
                    {globalDialogTips?.title}
                </div>
                <div className="tips-dialog-text">{globalDialogTips?.content}</div>
                <div className="tips-dialog-button" onClick={handleConfirm}>{globalDialogTips?.buttonContent}</div>
            </div>
        </DialogContent></Dialog>;
}
